<template>
  <div id="data-list-list-view" class="data-list-container">
    <h3>Users</h3>

    <vs-button
      @click="
        $router.push({ name: 'admin-sync-planday-users' }).catch(() => {})
      "
      id="sync-portals-button"
      class="mt-4"
      >Sync Users from Planday</vs-button
    >

    <vs-button
      @click="openConfirmInviteNewUsers()"
      id="invite-new-users-button"
      class="mt-4 ml-2"
      >Invite new Users</vs-button
    >

    <vs-button
      @click="$router.push({ name: 'admin-register-user' }).catch(() => {})"
      id="register-user-button"
      class="mt-4 ml-2"
      >Register new User</vs-button
    >

    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      :data="users"
      @selected="onUserClicked(selected.userId)"
      :noDataText="
        !hasSearched
          ? 'Type a name or e-mail in the search field and press enter to find a user'
          : 'No users found'
      "
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse flex-grow"
        style="justify-content: end"
      >
        <div style="display: flex">
          <vs-input
            type="search"
            v-model="query"
            v-on:keyup.enter="onSearch"
            border
            placeholder="Search"
            class="search mr-2"
          />

          <!-- ITEMS PER PAGE -->
          <vs-dropdown
            vs-trigger-click
            class="cursor-pointer mb-4 mr-4 items-per-page-handler"
          >
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  users.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : users.length
                }}
                of {{ queriedItems }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 40">
                <span>40</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <div>
            <vs-checkbox v-model="showUninvitedOnly" class="mr-4"
              >Show uninvited only</vs-checkbox
            >
            <vs-checkbox v-model="showDeactivatedOnly" class="mr-4"
              >Show deactivated only</vs-checkbox
            >
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="displayName">Name</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="isDeactivated">Status</vs-th>
        <vs-th sort-key="role">Role</vs-th>
        <vs-th sort-key="numVenues">Num. Venues</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.displayName }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.email }}</p>
            </vs-td>
            <vs-td>
              <p class="status-category">
                <vs-chip
                  :color="getStatusColor(!tr.isDeactivated)"
                  class="status-circle"
                ></vs-chip>
                {{ tr.isDeactivated ? "Deactivated" : "Active" }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.role }}</p>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="getNumVenuesColor(tr.numVenues)"
                class="product-order-status"
                >{{ tr.numVenues }}</vs-chip
              >
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      query: "",
      hasSearched: false,
      showUninvitedOnly: false,
      showDeactivatedOnly: false,

      users: [],

      selected: [],
      itemsPerPage: 10,
      isMounted: false,
    };
  },
  watch: {
    showUninvitedOnly() {
      this.getUsers();
    },

    showDeactivatedOnly() {
      this.getUsers();
    },
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.users.length;
    },
  },
  methods: {
    openConfirmInviteNewUsers() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure that you would like to invite new users?",
        accept: this.inviteNewUsers,
      });
    },

    inviteNewUsers: function () {
      this.$vs.loading();

      this.$http
        .post(process.env.VUE_APP_API + "/users/invites")
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "New Users invited",
          });
        })
        .catch((err) => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not invite new Users:" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onSearch: function () {
      if (this.query == "") {
        this.hasSearched = false;
        this.users = [];
      } else {
        this.getUsers();
        this.hasSearched = true;
      }
    },

    getStatusColor(status) {
      if (status === true) return "success";
      return "danger";
    },

    getUsers: function () {
      this.$vs.loading();

      let uninvitedOnly = "false";
      if (this.showUninvitedOnly === true) {
        uninvitedOnly = "true";
      }

      let deactivatedOnly = "false";
      if (this.showDeactivatedOnly === true) {
        deactivatedOnly = "true";
      }

      this.$http
        .get(
          process.env.VUE_APP_API +
            "/users?uninvitedOnly=" +
            uninvitedOnly +
            "&deactivatedOnly=" +
            deactivatedOnly +
            "&query=" +
            this.query
        )
        .then((resp) => {
          this.users = resp.data.map((u) => ({
            displayName: u.firstName + " " + u.lastName,
            ...u,
          }));
        })
        .catch((err) => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not search Users:" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onUserClicked(userId) {
      this.$router
        .push({ name: "admin-user", params: { userId: userId } })
        .catch(() => {});
    },

    getNumVenuesColor(numVenues) {
      if (numVenues == 0) return "warning";
      return "success";
    },
  },
  created() {},
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">

.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}


#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>